import { render, staticRenderFns } from "./tablePenanggungJawab.vue?vue&type=template&id=47ba2446&scoped=true"
import script from "./tablePenanggungJawab.vue?vue&type=script&lang=js"
export * from "./tablePenanggungJawab.vue?vue&type=script&lang=js"
import style0 from "./tablePenanggungJawab.vue?vue&type=style&index=0&id=47ba2446&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47ba2446",
  null
  
)

export default component.exports